import firebase from 'firebase';

import voucherCodes from 'voucher-code-generator';

const getCode = ()=>{
    let codes = voucherCodes.generate({
        length : 6,
        count : 1,
        charset : "23456789ABCDEFGHJKLMNPQRSTUVWXYZ"
    })
    return codes[0];
}

export const saveDonation = (donation)=>{
    return(dispatch)=>{

        return new Promise(async(resolve, reject)=>{
            
            

            try {

                let ref;

                if(!donation.id){
                    ref = firebase.firestore().collection('charities').doc(donation.charityId).collection('pledges').doc();
                    donation.createdAt =  firebase.firestore.FieldValue.serverTimestamp();
                    donation.id = ref.id;
                } else {
                    ref = firebase.firestore().collection('charities').doc(donation.charityId).collection('pledges').doc(donation.id);
                }

                donation.updatedAt = firebase.firestore.FieldValue.serverTimestamp();

                await ref.set(donation, { merge : true });

                resolve();

            }
            catch(e){
                console.error(e);
                reject(e)
            }
        

        })
        
    }
}


export const updateDonationUser = (key, value)=>{
    return(dispatch)=>{
        dispatch({
            type : 'UPDATE_INVENTORY_PLEDGE_USER',
            payload : {
                key : key,
                value : value
            }
        })
    }
}
export const updateDonationQuantity = (value)=>{
    return(dispatch)=>{
        dispatch({
            type : 'UPDATE_INVENTORY_PLEDGE_QUANTITY',
            payload : Number(value)
        })
    }
}

export const cancelInventoryDonation = ()=>{
    return (dispatch)=>{
        dispatch({
            type : 'UPDATE_INVENTORY_PLEDGE',
            payload : null
        })
    }
}
export const updateSelectedMapItem = (item)=>{
    return (dispatch)=>{
        dispatch({
            type : 'UPDATE_INVENTORY_MAP_SELECT',
            payload : item || {}
        })
    }
}
export const donateInventoryItem = ()=>{
    return async (dispatch, getState)=>{

        let item = getState().inventory.selectedRef;
        let user = getState().app.user

        return new Promise(async (resolve, reject)=>{
            dispatch({
                type : 'UPDATE_INVENTORY_PLEDGE',
                payload : {
                    ref : getCode(),
                    inventoryId : item.objectID,
                    status : 'pledged',
                    name : item.name,
                    quantity : 1,
                    givrEmail : user.email,
                    givrFirstName : user.firstName,
                    givrLastName : user.lastName,
                    charityId : item.charityId,
                    charityName : item.charityName
                }
            })
        })
    }
}


export const setInventoryItem = (searchResult) =>{
    return async (dispatch)=>{
        dispatch({
            type: 'LOAD_INVENTORY',
            payload : searchResult
        });

        if(searchResult){
            console.log(searchResult)
            let doc = await firebase.firestore()
                .collection('charities')
                .doc(searchResult.charityId)
                .collection('inventory')
                .doc(searchResult.objectID)
                .get()
    
            console.log(doc.data());
        }
       

    }
}



// WEBPACK FOOTER //
// ./src/actions/inventoryActions.js